
import React from 'react';
import { Radio, CheckboxGroup, Input } from '../../../common/components/formControls';
import { Panel, FormGroup, Col, ControlLabel, Well, Button } from 'react-bootstrap';
import { Field, FieldArray } from 'redux-form';
import withResourcesNamespace from '../../../common/components/withResourcesNamespace';

const colSize = { labelCol: 4, valueCol: 8 };

const Questionnaire = ({ t }) => {
	return (
		<div >
			<Panel>
				<Panel.Heading>{t('FamilyHistory')}</Panel.Heading>
				<Panel.Body>
					<Field name='question_20' component={CheckboxGroup} entries={[
						{ value: 'readingProblem', label: t('Question_20_ReadingProblem') },
						{ value: 'mathsProblem', label: t('Question_20_MathsProblem') }
					]} inline horizontal label={t('Question_20')} disabled {...colSize} />
					<FieldArray name='question_21' component={renderSiblings} t={t} label={t('Question_21')} />
				</Panel.Body>
			</Panel>
		</div>
	);
};

const renderSiblings = ({ fields, meta: { error, submitFailed }, t }) => <React.Fragment>
	<FormGroup className='row'>
		<Col componentClass={ControlLabel} sm={4}>
			{t('Question_21')}
		</Col>		
	</FormGroup>
	<div>
		{fields.map((sibling, index) => <Well key={index}>			
			<h5>{t('SiblingNumber', { number: index + 1 })}</h5>
			<Field name={`${sibling}.name`} component={Input} type='text' horizontal label={t('Question_21_Name')} {...colSize} disabled />
			<Field name={`${sibling}.age`} component={Input} type='text' horizontal label={t('Question_21_Age')} {...colSize} disabled />
			<Field name={`${sibling}.position`} component={Input} type='text' horizontal label={t('Question_21_Position')} {...colSize} disabled />
			<Field name={`${sibling}.dominantHand`} component={Radio} entries={[{ value: 'left', label: t('Left') }, { value: 'right', label: t('Right') }]}
				horizontal inline label={t('Question_21_DominantHand')} {...colSize} disabled />
		</Well>)}
	</div>
</React.Fragment>;

export default withResourcesNamespace(props => props.resourcesNamespace)(Questionnaire);